import { HttpClientModule } from '@angular/common/http';
import { NgModule } from "@angular/core";
import { DownloadHelper } from "../helper/download.helper";

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
  ],
  providers: [
    DownloadHelper
  ]
})
export class FileDownloadModule {
}

